import { formatToText } from "./parser";
import { unescapeBrackets } from "./parser/utils";
function getReadableDescription(description, abbreviate = false) {
    return unescapeBrackets(formatToText(description, abbreviate));
}
export default getReadableDescription;
